import * as Yup from 'yup';

export const kitPriceSchema = Yup.object({
  UnitPrice: Yup.number()
    .required('Price is required')
    .typeError('Price must be a number'),
});
